export default "__VITE_ASSET__Bhl1du_d__"